var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00208 18.9025V3.92595L4.34225 8.58579L2.92804 7.17157L9.9991 0.100505L17.0702 7.17157L15.656 8.58579L10.9961 3.92595V18.9025H9.00208Z",
    fill: "#CFD0E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8964 0.99694V15.9735L25.5562 11.3136L26.9704 12.7278L19.8993 19.7989L12.8283 12.7278L14.2425 11.3136L18.9023 15.9735V0.99694H20.8964Z",
    fill: "#CFD0E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIcon);
export default __webpack_public_path__ + "static/media/move_icon.c50332076ebd80e85e4455a81c507298.svg";
export { ForwardRef as ReactComponent };